import React from 'react';
import ReactDOM from 'react-dom';
import { LocaleProvider } from 'antd';
import enUS from 'antd/lib/locale-provider/en_US';
import '../styles/antd.min.css';
import {
    BrowserRouter as Router,
    Route,
    browserHistory,
} from 'react-router-dom';

import AppPage from './components/App/Index';
import ThankYou from './components/App/ThankYou';
import SignIn from './components/Admin/SignIn';
import StaffIndex from './components/Staff/IndexStaff';
import { ApolloClient, ApolloProvider, createNetworkInterface } from 'react-apollo'

const client = new ApolloClient({
    networkInterface: createNetworkInterface({
        uri: window.location.hostname === 'localhost' ? 'http://localhost:4050/graphql' :  'https://servertuvanlogo.uplevo.com/graphql'
    }),
});
function requireAuth() {
    if (!sessionStorage.id && window.location.href.split('/')[3] === 'stuff-contact-list') {
        return window.location.replace('/signin');
    }
    // else if (sessionStorage.id && sessionStorage.role === 'staff' && window.location.href.split('/')[3] !== 'stuff-contact-list') {
    //     return window.location.replace('stuff-contact-list');
    // }
    // else return;
}

ReactDOM.render(
    <LocaleProvider locale={enUS}>
    <ApolloProvider client={client}>
        <Router history={browserHistory}>
            <div>
                <Route path='/signin'  component={SignIn} />
                <Route exact path='/' component={AppPage} />
                <Route exact path='/get-started'  component={AppPage} />
                <Route path='/thank-you' component={ThankYou} />
                <Route path='/stuff-contact-list' onEnter={requireAuth()} component={StaffIndex} />
            </div>
        </Router>
    </ApolloProvider>
    </LocaleProvider>,
    document.getElementById('root')
);




// WEBPACK FOOTER //
// ./src/index.js